import { FC, PropsWithChildren } from 'react';
import { BUTTON_SIZES, Button } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { toolbarTheme } from '../../../constants';
import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';

type ToolbarButtonProps = {
  onClick: () => void;
  testId: string;
  tooltip: string;
};

export const ToolbarButton: FC<PropsWithChildren<ToolbarButtonProps>> = ({
  onClick,
  testId,
  children,
  tooltip,
}) => {
  const { aceEditorTheme } = useSideBySideEditorContext();

  return (
    <Tooltip tooltipContent={tooltip}>
      <Button
        data-test={testId}
        onClick={onClick}
        size={BUTTON_SIZES.MEDIUM}
        variant={toolbarTheme[aceEditorTheme].btnVariant}
      >
        {children}
      </Button>
    </Tooltip>
  );
};
